import { PaginationOutput } from 'kl-b2c-ui-kit';
import { Conference, ConferenceGallery, GetGallery, HttpResponse, IApiService, IConferenceApi } from 'types';

export class ConferenceApi implements IConferenceApi {
    constructor(private readonly apiService: IApiService) {}
    public getGalleryByConferenceId(request: GetGallery): Promise<HttpResponse<PaginationOutput<ConferenceGallery>>> {
        return this.apiService.request<PaginationOutput<ConferenceGallery>>({
            method: 'GET',
            url: '/Conference/GetGalleryByConferenceId',
            params: {
                ...request,
            },
        });
    }
    public getCurrent(): Promise<HttpResponse<Conference>> {
        return this.apiService.request<Conference>({
            method: 'GET',
            url: '/Conference/GetCurrent',
        });
    }

    public getArchived(): Promise<HttpResponse<Conference[]>> {
        return this.apiService.request<Conference[]>({
            method: 'GET',
            url: '/Conference/GetArchived',
        });
    }

    public getById(id: string): Promise<HttpResponse<Conference>> {
        return this.apiService.request<Conference>({
            method: 'GET',
            url: '/Conference/GetById',
            params: {
                id,
            },
        });
    }

    public getByName(id: string): Promise<HttpResponse<Conference>> {
        return this.apiService.request<Conference>({
            method: 'GET',
            url: '/Conference/GetByName',
            params: {
                name: id,
            },
        });
    }
}
